export default __webpack_public_path__ + "static/media/google_get_on.959855b5.png";